import { render } from "./ProjectAttachmentOffcanvas.vue?vue&type=template&id=b753fa4a&scoped=true&ts=true"
import script from "./ProjectAttachmentOffcanvas.ts?vue&type=script&lang=ts"
export * from "./ProjectAttachmentOffcanvas.ts?vue&type=script&lang=ts"

import "./ProjectAttachmentOffcanvas.scss?vue&type=style&index=0&id=b753fa4a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b753fa4a"]])

export default __exports__